import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import { useModals } from 'almanac-ui/Modal'
import { MediaFileViewerModal } from 'components/MediaFileViewerModal/MediaFileViewerModal'
import Styles from './MediaFileCard.module.scss'
import { MediaFilePreview } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/MediaFilePreview'
import { PressableContentTypeCard } from '../ContentTypeCard/ContentTypeCard'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import cx from 'classnames'
import { getAspectRatio } from 'utils/aspectRatio'

const Preview = ({ file }: FilePreviewProps) => {
  const { width, height } = file
  const aspectRatio = getAspectRatio(width, height)

  return (
    <div className={cx(Styles.preview, Styles[aspectRatio])}>
      <MediaFilePreview file={file} />
      {file.duration && file.duration > 0 && <VideoDuration duration={file.duration} />}
    </div>
  )
}

export const MediaFileCardContainer = ({ file, ...props }: FilePreviewProps) => {
  const { openModal } = useModals()
  const { title } = file

  return (
    <PressableContentTypeCard
      preview={() => <Preview file={file} />}
      title={title}
      {...props}
      onPress={() => openModal(MediaFileViewerModal, { file })}
    />
  )
}
